import React from 'react';

import LookupStatusBadge from '~components/LookupStatusBadge';
import TooltipPortal from '~components/TooltipPortal';
import { Row } from '~components/table-view-v3';

interface ComponentProps {
  row: Row;
}

// Statements use the same filled-badge look as every other status across the app —
// visual consistency is enforced by LookupStatusBadge. We add a TooltipPortal
// alongside the badge to surface `email_failure_reason` when a delivery has
// failed; the badge's id is what the tooltip targets, and a cursor:help cue is
// added inline so users know the badge is interactive.
const StatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const { status, email_failure_reason } = row || {};
  if (!status) return null;

  const showTooltip = status.tag === 'not_emailed' && !!email_failure_reason;
  const badgeId = `status-badge-${row?.id}`;

  return (
    <>
      <span style={showTooltip ? { cursor: 'help' } : undefined}>
        <LookupStatusBadge status={status} id={badgeId} />
      </span>
      {showTooltip && (
        <TooltipPortal targetId={badgeId} content={email_failure_reason} placement="top" limitWidth={300} />
      )}
    </>
  );
};

export default StatusBadge;
